import DealDeliveryPreferenceBadge from '@/components/deal/delivery-preference/deal-delivery-preference-badge';
import type { DeliveryPreference } from '@/models/types';
import DeliveryPreferenceFiltersComboBoxPopover from '../combobox-popovers/delivery-preference-filters-combobox-popover';
import type {
  DeliveryPreferenceFilterChipProps,
  DeliveryPreferenceFiltersState,
} from '../types';
import BaseFilterChip from './base-filter-chip';

const DeliveryPreferenceFilterChip = (
  props: DeliveryPreferenceFilterChipProps,
) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<DeliveryPreference, DeliveryPreferenceFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={DeliveryPreferenceFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        <DealDeliveryPreferenceBadge value="delivery" hideCopy />
      }
      filterName="Delivery Preference"
      filterQuantifier={{ singular: 'preference', plural: 'preferences' }}
      SelectedFilterBadge={DealDeliveryPreferenceBadge}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
    />
  );
};

export default DeliveryPreferenceFilterChip;
